const DealerMap = (props) => {
    return <div></div>;
};

export default DealerMap;
